<template>
  <div>
    <ca-heading :text="titleMixin" />

    <ca-page>
      <ca-form
        :key="formKey"
        :on-submit="onSubmit"
        :on-submit-success="onSubmitSuccess"
        :on-submit-error="onSubmitError"
        :error-message="errorMessage">
        <worker-shift-info-form
          :is-weekly-journey.sync="isWeeklyJourney"
          :is-draft="true"
          :shift-info="shiftInfo"
          :variable-shift="variableShift"
          :journey-type="journeyType"
          @set-shift-info="setWorkshiftInfo"
          @refresh-form="refreshForm"></worker-shift-info-form>
        <worker-form-footer save-label="Concluir" :on-back="goBack"></worker-form-footer>
      </ca-form>
    </ca-page>
  </div>
</template>

<script>
import { getBoxInformationErrorMessage } from 'packages/common/utils/utils';
import WorkerFormFooter from '../WorkerFormFooter';
import WorkerShiftInfoForm from './components/WorkerShiftInfoForm';
import {
  mapShiftInfo,
  createWorker,
  hasWorkerDraft,
  getWorkerDraft,
  setWorkerDraft,
} from '../../workersService';
import {
  getVariableShift,
  isWeeklyJourney,
  hasWorkshiftInfoDraft,
} from './workerShiftInfoService';
import { workerFormMixin } from '../../mixins/WorkerFormMixin';
import { clickToGoWorkerConcludeWizardStep } from '../../workerTrackerService';

const DEFAULT_JOURNEY_TYPE = { name: 'F' };
const DEFAULT_SHIFT_INFO = {
  weeklyHours: null,
  associatedWorkshifts: [],
};

export default {
  name: 'WorkerShiftInfoPage',
  components: {
    WorkerShiftInfoForm,
    WorkerFormFooter,
  },
  mixins: [workerFormMixin],
  props: {
    previousStep: Function,
    nextStep: Function,
  },
  data() {
    return {
      formKey: 0,
      shiftInfo: mapShiftInfo(DEFAULT_SHIFT_INFO),
      variableShift: {},
      journeyType: DEFAULT_JOURNEY_TYPE,
      errorMessage: null,
    };
  },
  computed: {
    workerBasicInfo() {
      return getWorkerDraft();
    },
    isWeeklyJourney() {
      return isWeeklyJourney(this.journeyType);
    },
  },
  created() {
    if (!hasWorkerDraft()) {
      this.$emit('on-reset-steps');
    } else {
      this.initData();
    }
  },
  methods: {
    async initData() {
      const { basicInfo: { name } } = this.workerBasicInfo;
      this.$store
        .dispatch('breadcrumb/setBreadcrumbProps', { workerName: name });

      if (hasWorkshiftInfoDraft()) {
        this.setWorkshiftInfo();
      }
    },
    setWorkshiftInfo() {
      try {
        const workshiftInfo = this.workerBasicInfo.workshiftInfo || DEFAULT_SHIFT_INFO;

        this.journeyType = workshiftInfo?.journeyType || DEFAULT_JOURNEY_TYPE;

        this.shiftInfo = this.isWeeklyJourney
          ? mapShiftInfo(workshiftInfo)
          : workshiftInfo;

        this.variableShift.workshiftId = getVariableShift(this.isWeeklyJourney, this.shiftInfo);
      } catch (error) {
        this.$toaster.error('Aconteceu um erro, por favor tente novamente.');
      }
    },
    goBack() {
      this.previousStep();
    },
    onSubmit() {
      clickToGoWorkerConcludeWizardStep();
      setWorkerDraft({
        workshiftInfo: {
          journeyType: this.journeyType,
          ...this.shiftInfo,
        },
      });

      return createWorker(getWorkerDraft());
    },
    onSubmitSuccess({ employee: workerId } = {}) {
      this.$toaster.success('Dados do contrato cadastrado com sucesso!');
      setWorkerDraft({ workerId });
      this.nextStep();
    },
    onSubmitError(error) {
      this.errorMessage = getBoxInformationErrorMessage(error);
    },
    refreshForm() {
      this.formKey++;
    },
  },
};
</script>
